import React, { Component } from 'react';
import { connect } from 'react-redux';
import { switchMainTabDispatch, unsetCommitteeTab } from '../actions';
import MeetingTile from './meeting-tile';
import CommitteeBox from './committee-box';
import Loading from './loading-component';

class OverviewPage extends Component {
	constructor( props ) {
		super( props );
		let meeting_index = 0;
		this.state = {
			current_meeting: false, meeting_index: meeting_index
		};
	}

	updateCurrentMeetingState( meeting ) {
		let newState = this.state;
		newState.current_meeting = meeting;
		this.setState( newState );
	}

	getNextAttendingCommittees() {
		let nextMeetings = (typeof this.props.meetings.meetings !== 'undefined'
		                   ) ? this.props.meetings.meetings : [];
		if ( nextMeetings.length > 0 ) {
			let committees = nextMeetings.map( meeting => {
				let ccodes_arr = meeting.post_content.split( ',' );
				let ccode = ccodes_arr.filter( ccode => this.props.myCommittees.includes( ccode ) )[ 0 ];
				return ccode;
			} );
			return [ ...new Set( committees ) ];
		} else {
			return [];
		}
	}

	getMyCommitteesForOverview() {
		const allCommittees = this.props.committees;
		const engagedCommittees = this.props.mostEngagedCommittees;
		let committees = [];
		//if engagedCommittees is less then 4, we want to still show a maximum of 4 committees.
		if ( engagedCommittees.length < 4 ) {
			//get all committees from that have upcoming meetings
			let nextCommittees = this.getNextAttendingCommittees()
			                         .filter( ccode => !engagedCommittees.includes( ccode ) );
			nextCommittees = nextCommittees.slice( 0, 4 - engagedCommittees.length );
			committees = [ ...engagedCommittees, ...nextCommittees ]; //put arrays together
			committees = [ ...new Set( committees ) ]; //remove all duplicates
			//if still less than 4, get any other committees from the mycommittees array.
			if ( committees.length < 4 ) {
				committees = committees.concat( [ ...this.props.myCommittees.slice( 0, 4 - committees.length ) ] );
			}
		} else if ( engagedCommittees.length >= 4 ) {
			//only use engaged committees
			committees = engagedCommittees.slice( 0, 4 );
		}
		return allCommittees.filter( committee => committees.includes( committee.code ) );
	}

	getCommitteesView() {
		let committeeHeading = 'All Committees';
		let allCommittees = this.props.committees;
		let shownCommittees, committeesToShow;
		let showingMyCommittees = false;
		let committeesToShowPublic = allCommittees.filter( committee => committee.isPublic ===  "1" || this.props.myCommittees.includes( committee.code ) );

		const defaultLength = 4;
		//If user has committees, show their committees.
		if ( typeof this.props.myCommittees !== 'undefined' && this.props.myCommittees.length > 0 ) {
			committeesToShow = this.props.myCommittees;
			committeeHeading = 'My Committees' + ` (${committeesToShow.length})`;
			// viewAllLength = this.props.myCommittees.length;
			showingMyCommittees = true;
		} else {
		
		}
		const myCommitteesToShow = allCommittees.filter( committee => this.props.myCommittees.includes( committee.code ) );
		shownCommittees = myCommitteesToShow.map( committee => {
			return (
				<CommitteeBox committee={ committee } is_part_of_committee={ showingMyCommittees } />
			);
		} );

		return (
			<div className="committees-overview-container">

				<div class="committees-title">
					<div class="committees-title__left-content">
						<h2 class="committees-title__heading-blue">
							<span>{ committeeHeading }</span>
						</h2>
						<div class="committees-title__divider-blue"></div>
					</div>
					<div class="committees-title__right-content">
						<button className="text-button view-all-meetings" onClick={ this.switchTabToCommittees.bind( this, 'committees' ) } type="button" >View All Committees ({ committeesToShowPublic.length })</button>
					</div>
				</div>
				<div className="committees-container">
					{ shownCommittees }
				</div>
			</div>
			
		);

	}

	switchTabToCommittees( tab ) {
		this.props.switchMainTabDispatch( tab );
	}

	getUpcomingMeetings() {
		if ( this.props.meetings === 'LOADING' ) {
			return (<Loading height={ 300 } width={ '100%' } />
			);
		}
		const meetings = (typeof this.props.meetings.meetings !== 'undefined'
		                 ) ? this.props.meetings.meetings : [];
		if ( Array.isArray( meetings ) && meetings.length > 0 ) {
			let index = this.state.meeting_index;
			//Update to the first index if current meeting isn't set yet.
			if ( this.state.current_meeting === false && typeof meetings[ index ] !== 'undefined' ) {
				this.updateCurrentMeetingState( this.props.meetings.meetings[ index ] );
			} else {
				return <MeetingTile meeting={ this.state.current_meeting } upcomingMeetingSection={ true } />;
			}
		} else {
			return this.getNoUpcomingMeetingsBanner();
		}

	}

	getNoUpcomingMeetingsBanner() {
		return (<div className="information-banner">
				<span className="glyphicon glyphicon-info-sign" />
				<span className="sr-only">No Upcoming Meetings for Your Committees</span>
				<p>You do not have any upcoming meetings yet.</p>
			</div>
		);
	}

	navigateMeeting( nextMeeting ) {
		let newState = this.state;
		const meetings = this.props.meetings.meetings;
		// if next meeting, move up 1 index, if previous meeting, go down index.
		const index = (nextMeeting
		              )
			? newState.meeting_index + 1
			: newState.meeting_index - 1;
		newState.meeting_index = index;
		newState.current_meeting = meetings[ index ];
		this.setState( newState );
	}

	getMeetingNavigator() {
		const meetings = this.props.meetings.meetings;
		const current_page = this.state.meeting_index;
		
		return (
			<div className="meeting-navigator-container">
				<div className="meeting-dots">
					{meetings.map((meeting, index) => (
						<li key={index} className={`meeting-dot ${current_page === index ? 'active' : ''}`}>
							<button 
								onClick={() => {
									let newState = this.state;
									newState.meeting_index = index;
									newState.current_meeting = meetings[index];
									this.setState(newState);
							}}
							aria-label={`Go to meeting ${index + 1} of ${meetings.length}`}
						/>
						</li>
					))}
				</div>
			</div>
		);
	}

	render() {
		const meetings = (typeof this.props.meetings.meetings !== 'undefined'
		                 ) ? this.props.meetings.meetings : [];
		const upcomingMeetingCount = (typeof this.props.meetings.total_upcoming_meetings !== 'undefined'
		                             )
			? this.props.meetings.total_upcoming_meetings
			: 0;
		if ( ( Array.isArray( meetings )
		     ) && meetings.length > 0 && this.state.current_meeting === false ) {
			if ( typeof meetings[ 0 ] !== 'undefined' ) {
				this.updateCurrentMeetingState( meetings[ 0 ] );
			}
		}
		const current_page = this.state.meeting_index + 1;
	

		return (
			<div className="overview-container container">
				<div class="committees-title">
					<div class="committees-title__left-content">
						<h2 class="committees-title__heading-blue">
							<span>My Upcoming Meetings</span>
						</h2>
						<div class="committees-title__divider-blue"></div>
					</div>
					<div class="committees-title__right-content">
						<button className="text-button view-all-meetings" onClick={this.switchTabToCommittees.bind(this, 'meetings')} type="button">
							View All ({upcomingMeetingCount})
						</button>
					</div>
				</div>
				{this.props.meetings === 'LOADING'  ? (
					<Loading height={300} width={'100%'} />
				) : (
					<>
				<div className="meetings-navigator-wrapper">
				{this.props.meetings === 'LOADING'  ? (
					<Loading height={300} width={'100%'} />
				) : (
					<>
						<button 
							className={`meeting-navigator-button no-hover ${current_page <= 1 ? 'disabled' : ''}`}
							onClick={this.navigateMeeting.bind(this, false)}
							type="button"
							disabled={current_page <= 1}
						>
							<i className="fa-solid fa-chevron-left" aria-hidden="true" />
							<span className="sr-only">Previous Page ({current_page - 1})</span>
						</button>

						{this.getUpcomingMeetings()}

						<button 
							className={`meeting-navigator-button no-hover ${current_page >= meetings.length ? 'disabled' : ''}`}
							onClick={this.navigateMeeting.bind(this, true)}
							type="button"
							disabled={current_page >= meetings.length}
            				>
							<i className="fa-solid fa-chevron-right" aria-hidden="true" />
							<span className="sr-only">Next Page ({current_page + 1})</span>
						</button>
					</>
					)}
				</div>
				{Array.isArray(meetings) && meetings.length > 1 && this.getMeetingNavigator()}
					{this.getCommitteesView()}
					</>
				)}
			</div>
		);
	}

}

function mapStateToProps( { currentTabs, myCommittees, requestedCommittees, myCommitteeTab, meetings, committees, mostEngagedCommittees } ) {
	return {
		currentTabs,
		myCommittees,
		requestedCommittees,
		myCommitteeTab,
		meetings,
		committees,
		mostEngagedCommittees

	};
}

export default connect( mapStateToProps, {
	switchMainTabDispatch, unsetCommitteeTab
} )( OverviewPage );